// const ORIGIN = '6afa10fc-7173-4d6e-82c1-1ec4f709e721' // SANDBOX
const ORIGIN = '821f984f-ce48-4bb9-8a98-af337b17474a' // PRODUCAO

module.exports = {
  CONNECTION: {
    ORIGIN,
    // URL: 'https://sandbox.sapiensbank.com.br', // SANDBOX
    // URL: 'https://b3d5-168-197-157-49.ngrok-free.app',
    // URL: 'http://localhost:8085',
    URL: 'https://api.attogroup.com.br', // Build
    // URL: 'http://104.236.77.30:9585', // PRODUCAO
  },
  IMAGES: {
    // URL: `https://sapiensbank.com.br/whitelabel/${ORIGIN}`, // PRODUCAO
    URL: `https://adm.attogroup.com.br`,
  },
  SOCKET: {
    // URL: 'https://api.wsbtech.co:9086', // PRODUCAO
    URL: 'https://api.attogroup.com.br:9087', // SANDBOX
    // URL: 'http://localhost:9086',
  },
  STORAGE: {
    NAME: 'neoin-webadmin',
  },
  DICTIONARY: {
    PURCHASE: {
      OPEN: 'Rentabilizando',
      APPROVED: 'Aprovado',
      ANALYSIS: 'Em análise',
      FREEZE: 'Pausado',
    },
    ACCOUNT: {
      PENDENT: 'Cadastro em análise',
      STARTED: 'Cadastro Iniciado',
      NUMBER_PENDENT: 'Cadastro em andamento',
      // ACTIVE: 'Conta ativa',
      BLOCKED: 'Conta bloqueada',
    },
    ACESS: {
      SPECIALIST: 'Especialista',
      GESTOR: 'Gestor',
      DIRECTOR: 'Diretor',
      FINANCIAL: 'Financeiro',
      LEGAL: 'Jurídico',
      RI: 'Relacionamento com Investidor',
      RH: 'Gestor de usuários',
    },
    USER_STATUS: {
      NEW: 'Novo',
      ACTIVE: 'Ativo',
      INACTIVE: 'Inativo',
      VACATION: 'Férias',
    },
  },
  STATES: [
    ['Acre', 'AC'],
    ['Alagoas', 'AL'],
    ['Amapá', 'AP'],
    ['Amazonas', 'AM'],
    ['Bahia', 'BA'],
    ['Ceará', 'CE'],
    ['Distrito Federal', 'DF'],
    ['Espírito Santo', 'ES'],
    ['Goiás', 'GO'],
    ['Maranhão', 'MA'],
    ['Mato Grosso', 'MT'],
    ['Mato Grosso do Sul', 'MS'],
    ['Minas Gerais', 'MG'],
    ['Pará', 'PA'],
    ['Paraíba', 'PB'],
    ['Paraná', 'PR'],
    ['Pernambuco', 'PE'],
    ['Piauí', 'PI'],
    ['Rio de Janeiro', 'RJ'],
    ['Rio Grande do Norte', 'RN'],
    ['Rio Grande do Sul', 'RS'],
    ['Rondônia', 'RO'],
    ['Roraima', 'RR'],
    ['Santa Catarina', 'SC'],
    ['São Paulo', 'SP'],
    ['Sergipe', 'SE'],
    ['Tocantins', 'TO'],
  ],
}
